import { render, staticRenderFns } from "./ZaloToDoPage.vue?vue&type=template&id=72100713&scoped=true"
import script from "./ZaloToDoPage.vue?vue&type=script&lang=js"
export * from "./ZaloToDoPage.vue?vue&type=script&lang=js"
import style0 from "./ZaloToDoPage.vue?vue&type=style&index=0&id=72100713&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72100713",
  null
  
)

export default component.exports